import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface OverlayState {
    renderContent?: any;
    status?: 0 | 1 //0 close 1 open
}
const initialState: OverlayState = {
    status: 0
}

export const overlaySlice = createSlice({
    name: 'overlay',
    initialState: initialState,
    reducers: {
        closeOverlay: (state) => {
            state.renderContent = undefined
            state.status = 0
        },
        setOverlayContent: (state, action: PayloadAction<any>) => {
            state.renderContent = action.payload;
            state.status = 1
        },
    },
})

// Action creators are generated for each case reducer function
export const {setOverlayContent,closeOverlay } = overlaySlice.actions

export default overlaySlice.reducer